import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';

import { CompDetailService } from '@b2b/core/api/detail/detail.service';

import { MetaDefinition } from '@angular/platform-browser';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';

import { UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';
import { ImageOptimizerService } from '@sparro/app/core/helpers/image-optimizer';
import _ from 'lodash';

@Component({
  selector: 'app-entries',
  templateUrl: './entries.component.html',
  styleUrls: ['./entries.component.scss']
})

export class EntriesComponent implements OnInit {
  compSlug: string;
  page: number;
  competitionEntries = [];
  next: string;
  slug: string;
  results = [];

  resultDate: boolean = true;
  showSpinner: boolean = false;
  isLoading: boolean = false;
  loadMore: boolean = false;
  connectionType: string = 'project';
  host: string = UNI_CONSTANTS.HOSTS.ARENA;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public metaService: MetaService,
    private detailService: CompDetailService,
    public dialog: MatDialog,
    public imageOptimizer: ImageOptimizerService
  ) {
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.compSlug = this.route.parent.snapshot.params.comp_slug;
    this.detailService.fetchCompetition(
      this.compSlug, (competition) => { this.connectionType = competition.entry_type;
    });
    this.getEntries();
  }

  getEntries(): void {
    this.detailService.getEntriesByCompetition(this.compSlug, this.page).subscribe(
      (response: any) => {
        this.competitionEntries = [...this.competitionEntries, ...response.results];
        this.next = response.next;
        if (this.next) {
          this.page = parseInt(this.next.split('=')[1]);
        }

        this.results = _.chain(this.competitionEntries)
          .groupBy('entry_type')
          .map((value, key) => (
            { entry_type: key, entries: value }))
          .value();

        // console.log(this.results);
        this.isLoading = false;
        this.loadMore = false;
        this.updateMetaInfo();
      },
      (err) => {
        console.log(err);
        this.isLoading = false;
        this.loadMore = false;
      });
  }

  loadMoreEntries(): void {
    this.loadMore = true;
    this.getEntries();
  }

  updateMetaInfo(): void {
    this.detailService.fetchCompetition(this.compSlug, (competition: any) => {
      let metaInfo: MetaDefinition[] = [];
      const title = `${competition.title} ${competition.disciplines[0].name} Competition | ${competition.location?.name ?
        competition.location.name : competition.location.country.name} | Results`;
      const entryTitles = this.results[0]?.entries?.slice(0, 5).map(
        (entry) => {
          if (entry.connection_type === 'project') {
            return entry.project.content.title + ', ';
          } else if (entry.connection_type === 'publication') {
            return entry.publication.title + ', ';
          } else if (entry.connection_type === 'blog') {
            return entry.blog.title + ', ';
          }
        }
      );

      const description = `View results of ${competition.title}. ${competition.location?.name ? competition.location.name :
        competition.location?.country?.name}. Entries | ${this.results.length ? entryTitles : ' '}`;
      const image = competition.image ?  this.renderImage(competition.image) : '';
      metaInfo = [
        { name: 'title', content: title },
        { name: 'description', content: description },
        { name: 'url', content: window.location.href },
        { name: 'image', content: image },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description},
        { name: 'twitter:url', content: window.location.href },
        { name: 'twitter:image', content: image },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: window.location.href },
        { property: 'og:image', content: image },
        { property: 'og:image:alt', content: title },
        { property: 'og:type', content: 'website' }
      ];
      metaInfo.forEach(meta => {
        this.metaService.updateMetaInfo(meta);
      });
      this.metaService.updateMeta(metaInfo);
      this.metaService.updateTitle(title);
      this.metaService.createCanonicalURL();
    });
  }

  renderImage(image: string): string {
    return this.imageOptimizer.renderImage(image, window.innerWidth, '');
  }
}
